import classNames from 'classnames'
import Button from '../../components/Button'
import Card from '../../components/Card'

export default function ReasonSelectionStep({
  reasons,
  selectedReasonId,
  onSelect,
  onNext,
}) {
  let disabled = !selectedReasonId

  return (
    <div className='flex flex-col w-full h-full items-center justify-center'>
      <Card withGradient>
        <div className='px-24 py-12 flex text-white gap-36 items-center'>
          <div className='flex flex-col gap-4 w-72 items-start'>
            <div className='text-2xl font-bold'>
              Was trifft auf dich zu?
            </div>
            <div className='text-neutral-500 text-lg'>
              Wähle bitte den Hauptgrund für deine Kündigung. Danach zeigen wir dir passende Möglichkeiten, wie wir dich unterstützen können.
            </div>
            <Button
              variant='secondary'
              className='text-primary'
              disabled={disabled}
              onClick={() => !disabled && onNext()}
            >
              <strong className={classNames('px-12 font-bold', !disabled && 'text-primary')}>Weiter</strong>
            </Button>
          </div>

          <div className='flex flex-col gap-4'>
            {reasons.map((reason) => (
              <div
                key={reason.id}
                className={classNames(
                  'cursor-pointer p-5 rounded-2xl border-2 min-w-[340px] transition-colors duration-200',
                  selectedReasonId === reason.id
                    ? 'border-primary text-primary bg-secondary'
                    : 'border-neutral-800 text-neutral-300 hover:border-primary/60'
                )}
                onClick={() => onSelect(reason.id)}
              >
                <div className='text-lg font-semibold'>
                  {reason.title}
                </div>
                <div className='text-sm text-neutral-500 mt-1'>
                  {reason.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  )
}
